/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PracticeSettings } from '../../models/practice-settings';

export interface ConfigSettingSavePracticeSettings$Params {
  type?: string | null;
  practiceId?: string | null;
      body: PracticeSettings
}

export function configSettingSavePracticeSettings(http: HttpClient, rootUrl: string, params: ConfigSettingSavePracticeSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, configSettingSavePracticeSettings.PATH, 'post');
  if (params) {
    rb.query('type', params.type, {});
    rb.query('practiceId', params.practiceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

configSettingSavePracticeSettings.PATH = '/configsetting/save';
